import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'

const tintedBg = (token) => `color-mix(in srgb, ${token} 20%, transparent)`

const VARIANT_CONFIG = {
  primary: { color: 'var(--color-primary-600, var(--color-primary-500))', bg: tintedBg('var(--color-primary-500)') },
  secondary: { color: 'var(--color-secondary-500)', bg: tintedBg('var(--color-secondary-500)') },
  success: { color: 'var(--color-success-700, var(--color-success-500))', bg: tintedBg('var(--color-success-500)') },
  warning: { color: 'var(--color-warning-700, var(--color-warning-500))', bg: tintedBg('var(--color-warning-500)') },
  danger: { color: 'var(--color-danger-600, var(--color-danger-500))', bg: tintedBg('var(--color-danger-500)') },
  info: { color: 'var(--color-info-600, var(--color-info-500))', bg: tintedBg('var(--color-info-500)') },
  neutral: { color: 'var(--color-neutral-600)', bg: tintedBg('var(--color-neutral-500)') }
}

const useStyles = makeStyles(() => ({
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '2px 10px',
    borderRadius: '9999px',
    fontSize: 'var(--text-size-xs, 0.72rem)',
    fontWeight: 600,
    lineHeight: '18px',
    whiteSpace: 'nowrap'
  },
  dot: {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    flexShrink: 0,
    backgroundColor: 'currentColor'
  }
}))

function StatusBadge ({ variant, dot, children, className, style, title }) {
  const classes = useStyles()
  const config = VARIANT_CONFIG[variant] || VARIANT_CONFIG.neutral

  return (
    <span
      className={clsx(classes.badge, className)}
      style={{ color: config.color, backgroundColor: config.bg, ...style }}
      title={title}
    >
      {dot && <span className={classes.dot} />}
      {children}
    </span>
  )
}

StatusBadge.defaultProps = {
  variant: 'neutral',
  dot: true
}

StatusBadge.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'neutral']),
  dot: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  title: PropTypes.string
}

export default StatusBadge
